import axios from "axios";
import { useDispatch } from "react-redux";
import { useRef, useEffect, useCallback } from "react";

import BASE_URL from "../constants/baseURL";
import { alert } from "../redux/slices/alertSlice";
import { apiError } from "../redux/slices/loaderSlice";
import { deleteAccessToken } from "../redux/slices/memberSlice";

export default function useAxiosCustomToken({
  baseURL = "adn_api",
  customBaseURL = "",
  customAuthToken = "",
  disableAuthToken = false,
} = {}) {
  var authToken = "";
  const dispatch = useDispatch();

  const axiosInstance = useRef(axios.create());
  const token = sessionStorage.getItem("authToken");
  const ida_sso_login = sessionStorage.getItem("ida_sso_login");

  useEffect(() => {
    axiosInstance.current = axios.create({
      headers: {
        ...(!disableAuthToken &&
          ida_sso_login === null && {
            Authorization: customAuthToken || authToken,
          }),

        // "x-sso-token": customAuthToken || authToken || token,

        ...(ida_sso_login === "true" && {
          "x-sso-token": customAuthToken || authToken || token,
        }),

        "content-type": "application/json",
      },

      ...(Boolean(customBaseURL)
        ? { baseURL: customBaseURL }
        : {
            baseURL: BASE_URL[baseURL].url + BASE_URL[baseURL].version,
          }),

      validateStatus: (status) => status < 500,
    });
  }, [authToken, baseURL, customAuthToken, customBaseURL, disableAuthToken]);

  return useCallback(
    ({
      url,
      method = "GET",
      data,
      params,
      customAuthToken,
      disableRedirect = false,
      disableError = false,
    }) =>
      axiosInstance
        .current({
          url: url,
          method: method,
          data: data,
          params: params,
          // headers: {
          //   ...(!disableAuthToken && {
          //     Authorization: customAuthToken || authToken,
          //   }),
          // },
        })
        .then((response) => {
          if (response.data.detail?.code === "#401") {
            dispatch(
              alert({
                message:
                  "Could not validate your credentials. Please log in again",
                type: "error",
              })
            );
            return dispatch(deleteAccessToken());
          }

          if (response.status > 201 || !response.data.status) {
            if (!disableError) {
              dispatch(
                alert({
                  message: response.data?.error || "Error loading data!",
                  type: "error",
                })
              );
            }

            if (!disableRedirect) {
              dispatch(apiError(response.data?.message?.traceID));

              throw new Error();
            } else {
              return { status: false, message: response.data.error };
            }
          }

          return response.data;
        }),
    [dispatch, authToken, disableAuthToken]
  );
}
